import { z } from 'zod';

export const RelationshipType = z.enum([
  'COLLEAGUE',
  'CUSTOMER',
  'SUPPLIER',
  'PARTNER',
  'INVESTOR',
  'FRIEND',
  'OTHER',
]);
export type RelationshipType = z.infer<typeof RelationshipType>;

export const RelationshipDTO = z.object({
  id: z.string(),
  aId: z.string(),
  bId: z.string(),
  type: RelationshipType,
  strength: z.number(),
  hidden: z.boolean(),
  note: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type RelationshipDTO = z.infer<typeof RelationshipDTO>;

export const RelationshipCreateInput = z.object({
  aId: z.string().min(1),
  bId: z.string().min(1),
  type: RelationshipType.default('OTHER'),
  strength: z.number().int().min(0).max(100).default(50),
  hidden: z.boolean().default(false),
  note: z.string().trim().max(500).optional().nullable(),
});
export type RelationshipCreateInput = z.infer<typeof RelationshipCreateInput>;

export const RelationshipUpdateInput = z.object({
  type: RelationshipType.optional(),
  strength: z.number().int().min(0).max(100).optional(),
  hidden: z.boolean().optional(),
  note: z.string().trim().max(500).optional().nullable(),
});
export type RelationshipUpdateInput = z.infer<typeof RelationshipUpdateInput>;

export const RelationshipResponse = z.object({ relationship: RelationshipDTO });
export type RelationshipResponse = z.infer<typeof RelationshipResponse>;
